// **************************************************
// Sticky nav
// **************************************************
const stickyNav = document.querySelector('.content-switcher__sticky');

function activeSticky() {
  const contentBanner = document.querySelector('.content-switcher__banner');
  const bannerHeight = contentBanner.offsetHeight;

  const scrolled = document.documentElement.scrollTop || document.body.scrollTop;

  if (scrolled > bannerHeight) {
    stickyNav.classList.add('is-active');
  } else {
    stickyNav.classList.remove('is-active');
  }
}

if (stickyNav) {
  window.addEventListener('scroll', activeSticky);
}

// ********* Change URL according to selected subscription ***********************//
attachEvent('.subscriptions-slider__nav', 'click', (ev) => {
  ev.preventDefault();
  const cat = ev.target.closest('.subscriptions-slider__nav-link').innerHTML;
  window.history.pushState(null, null, '?abonma=' + cat.toLowerCase());
});
